import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import LogoutIcon from '../../assets/logout.svg';
import useLogoutStyles from './logout.styles';
import CONSTANTS from '../../utils/constants';
import STATIC_TEXT from '../../content/common.json';
import Dialog from '../portico/dialog/dialog';
import Spacing from '../portico/spacing/spacing';
import WarningIcon from '@material-ui/icons/Warning';
import { useDispatch } from 'react-redux';
import { logout } from '../../stores/async/identity-async-actions';

interface LogoutProps {
  showButton?: boolean
}

const Logout: React.FC<LogoutProps> = (props): JSX.Element => {
  const classes = useLogoutStyles();
  const dispatch = useDispatch();

  const [openDialog, setOpenDialog] = useState(false);

    const onLogout = () => {
        dispatch(logout())
    }

  const onOpenDialog = () => {
    setOpenDialog(true);
  }

  const onCloseDialog = () => setOpenDialog(false);

  return (
    <>
      <Button
        disableRipple
        className={props.showButton ? null : classes.button}
        onClick={onOpenDialog}
        data-testid="app-logout"
        data-cy="logout-btn"
        color={props.showButton ? 'primary' : 'secondary'}
        variant={props.showButton ? 'contained' : 'text'}
      >
        {!props.showButton && <img src={LogoutIcon} alt="Logout" className={classes.icon} />}
        <span style={{ color: props.showButton ? 'white' : 'inherit' }}>Log Out</span>
      </Button>
      <div>
        <Dialog
          titleIcon={<WarningIcon fontSize="large" className={classes.titleIcon} />}
          title={STATIC_TEXT.logoutDialog.title}
          open={openDialog}
          cancelBtnLabel='Cancel'
          onCancel={onCloseDialog}
          okBtnLabel='Logout'
          onOk={onLogout}
          disableActions={false}
          okBtnClasses={classes.btn_primary}
          {...{children:
            <>
              <Typography variant="body1">{STATIC_TEXT.logoutDialog.body}<a href={CONSTANTS.FIRST_CITIZENS_LOGIN} target="_blank" rel="noopener noreferrer">{CONSTANTS.FIRST_CITIZENS_LOGIN}</a></Typography>
              <Spacing variable="spacing-base-x2" />
            </>
          }}
        />
      </div>
    </>
  );
};

export default Logout;